module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/quick_easy--xxs@1x-a3144fa385447f910c3e747ec4c45044.png";